import { FadeUp, SectionLabel } from "@/components/Reveal";

const CLIENTS = [
  "Graville Enterprises Ltd",
  "Lamu Breeze Investments Ltd",
  "Jua Kali Contractors' Umbrella Holdings Ltd",
  "Uswazi Fronts Ltd",
  "Pitch Point Sales & Marketing Co. Ltd",
  "Aldarwiche Agency Ltd",
  "Al-Suwedi International Recruiting Agency Ltd",
  "X-Drive Car Parts Ltd",
  "Supa Hauliers Ltd",
  "Anand Maisonettes Ltd",
  "Africa Khula Ltd",
  "Value Bakery",
  "Conclave 93 Ltd",
  "Zaheen Hauliers Ltd",
  "Wanajeti Jua Kali Self Help Association",
];

export default function Clients() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-28 lg:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <SectionLabel>Corporate Clientele</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl leading-tight">
            Trusted by Enterprises <span className="text-gold">Across Kenya</span>
          </h2>
          <p className="mt-6 text-ink-dim max-w-xl leading-relaxed">
            A selection of the corporate clients the firm is privileged to
            serve — across logistics, manufacturing, recruitment, property and
            trade.
          </p>
        </FadeUp>
      </div>

      <FadeUp delay={0.2} className="mt-16">
        <div
          data-testid="client-marquee-container"
          className="relative border-y border-gold/15 py-10 bg-navy-900/30"
          style={{
            maskImage:
              "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
            WebkitMaskImage:
              "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
          }}
        >
          <div className="flex w-max animate-marquee gap-0">
            {[...CLIENTS, ...CLIENTS].map((c, i) => (
              <div key={i} className="flex items-center shrink-0">
                <span className="font-editorial text-2xl sm:text-3xl text-ink-dim hover:text-gold transition-colors duration-300 whitespace-nowrap px-10">
                  {c}
                </span>
                <span className="text-gold/50 text-xs">&#9670;</span>
              </div>
            ))}
          </div>
        </div>
      </FadeUp>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10">
        <FadeUp delay={0.3}>
          <p className="font-mono text-xs text-ink-muted tracking-[0.2em] uppercase">
            15 corporate relationships &mdash; and counting
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
